import { AuditReport } from './audit-report';
export class AuditReportList {
  count   !: number;
  next    !: string;
  previous!: string;
  results !: AuditReport[];

  constructor() {}
}
